<div *ngIf="!isLoaded">
    <h6 class="montserrat-medium text-gray-500 mb-2">
        Checking if campaign starts in less than 2 working days ...
    </h6>
</div>

<div *ngIf="step == 0 && isLoaded">
    <h6 class="montserrat-medium text-gray-500 mb-2">{{ getTitle() }}</h6>
    <p class="mb-4">
        {{ getPauseDescription() }}
    </p>

    <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
        <button
            *ngIf="canPauseCampaign()"
            (click)="pauseCampaign()"
            class="btn btn-md btn-gray-500"
        >
            yes
        </button>
    </div>
</div>

<div *ngIf="step == 1 && isLoaded">
    <p class="mb-4">Please mention the pause date</p>
    <mat-form-field class="form-group dark-input mb-2">
        <mat-label>Pause Date</mat-label>
        <input
            matInput
            [matDatepicker]="startDatePicker"
            [matDatepickerFilter]="dateFilter"
            [min]="minStartDate"
            [max]="endDate"
            [(ngModel)]="upcomingStatusDate"
            (dateChange)="onUpcomingStatusDateChanged($event.value)"
            name="pauseDate"
        />
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <div class="d-flex align-items-center justify-content-center">
        <button
            [disabled]="!isUpcomingDateWithinRange()"
            (click)="moveToStepTwo()"
            class="btn btn-md btn-gray-500"
        >
            Ok
        </button>
    </div>
</div>

<div *ngIf="step == 2 && isLoaded">
    <h6 class="montserrat-medium text-gray-500 mb-2">{{ getTitle() }}</h6>
    <p class="mb-4">
        {{ getPauseDescription() }}
    </p>

    <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
        <button
            [disabled]="!canPauseCampaign() || (!isAdminLivePause && !isUpcomingDateWithinRange())"
            (click)="pauseCampaign()"
            class="btn btn-md btn-gray-500"
        >
            yes
        </button>
    </div>
</div>
